var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "model" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "body" }, [
      _c("iframe", {
        class: { origin: _vm.type === "origin" },
        attrs: { src: _vm.url, frameborder: "0" },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "top" }, [
      _c("div", { staticClass: "time" }, [
        _c("span", [_vm._v("12:00")]),
        _vm._v(" "),
        _c("span", { staticClass: "clock" }, [_c("i")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bang" }, [
        _c("span", { staticClass: "dot" }),
        _vm._v(" "),
        _c("span", { staticClass: "line" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "single" }, [
        _c("i", { staticClass: "i1" }),
        _c("i", { staticClass: "i2" }),
        _c("i", { staticClass: "i3" }),
        _c("i", { staticClass: "i4" }),
        _vm._v("\n      4G\n      "),
        _c("div", { staticClass: "battery" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }